/* global document */
const get = require('lodash/get');
const isEmpty = require('lodash/isEmpty');

require('core-js/fn/array/from');
require('core-js/fn/array/find');

const constants = Object.freeze({
	ACTIVE_CATEGORY_CLASS: 'active-cat',
});

const searchFacets = {
	constants,
};


searchFacets.getFacetCheckboxes = function() {
	return Array.from(
		document.querySelectorAll('.search-facets-module .multi-select-facet-checkbox')
	);
};

searchFacets.getFacetCategories = function() {
	return Array.from(
		document.querySelectorAll('.customer-friendly-categories .card.cfc .subcategories-list .subcategory')
	);
};

searchFacets.getFacetValuesFromDom = function() {
	const multiSelectFacetCheckboxes = searchFacets.getFacetCheckboxes();

	// Multi-select facet values
	const facetValues = multiSelectFacetCheckboxes.reduce((accumulator, checkbox) => {
		const queryName = checkbox.getAttribute('data-query-name');
		if (!(queryName in accumulator)) {
			accumulator[queryName] = '';
		}

		if (checkbox.checked) {
			const checkboxName = checkbox.getAttribute('name');
			if (!accumulator[queryName]) {
				accumulator[queryName] = checkboxName;
			} else {
				accumulator[queryName] = `${accumulator[queryName]},${checkboxName}`;
			}
		}

		return accumulator;
	}, {});

	// Category facet value
	const facetCategories = searchFacets.getFacetCategories();
	const activeCategoryLink = facetCategories.find(
		(categoryLink) => categoryLink.classList.contains(constants.ACTIVE_CATEGORY_CLASS)
	);
	if (activeCategoryLink) {
		const $parentFacetWrapper = rp$(activeCategoryLink).closest('.facet-wrapper');
		if ($parentFacetWrapper.length === 1) {
			const categoryQueryName = $parentFacetWrapper.attr('data-query-name');
			if (categoryQueryName) {
				facetValues[categoryQueryName] = activeCategoryLink.getAttribute('data-cfc-node-id');
			}
		}
	}

	return facetValues;
};

searchFacets.getAvailableSearchFacetQueryNames = function() {
	const facets = Array.from(
		document.querySelectorAll('.search-facets-module .facet-wrapper')
	);

	return facets.map((facet) => facet.getAttribute('data-query-name'));
};

searchFacets.updateSelectedFacetCheckboxes = function(selectedFacetData) {
	const selectedFacets = isEmpty(selectedFacetData) ? {} : selectedFacetData;
	const checkboxes = searchFacets.getFacetCheckboxes();

	checkboxes.forEach((checkbox) => {
		const checkboxName = checkbox.getAttribute('name');
		const checkboxQueryName = checkbox.getAttribute('data-query-name');
		const buckets = get(selectedFacets, `[${checkboxQueryName}]`, []);
		const checked = buckets.includes(checkboxName);
		checkbox.checked = checked;
	});
};

function setFacetsInteractiveState(enabled) {
	// Multi select facets
	const checkboxes = searchFacets.getFacetCheckboxes();
	checkboxes.forEach((checkbox) => {
		checkbox.disabled = !enabled;
	});

	// Category facet
	const categoryFacetWrapper = document.querySelector('.facet-wrapper.categories-facet');
	if (categoryFacetWrapper) {
		if (enabled) {
			categoryFacetWrapper.classList.remove('disabled');
		} else {
			categoryFacetWrapper.classList.add('disabled');
		}
	}
}

searchFacets.disableFacets = function() { setFacetsInteractiveState(false); };
searchFacets.enableFacets = function() { setFacetsInteractiveState(true); };

module.exports = searchFacets;
